"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoLightbox = void 0;
class VideoLightbox {
    static init() {
        const toggleLightBox = document.querySelectorAll('section.video .js-toggle-lightbox');
        const lightbox = document.querySelectorAll('section.video .video-lightbox');
        if (!toggleLightBox || !lightbox) {
            return;
        }
        toggleLightBox.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                var _a, _b, _c;
                if (toggle.classList.contains('video-lightbox')) {
                    toggle.classList.remove('open');
                }
                else {
                    console.log((_a = toggle.parentElement) === null || _a === void 0 ? void 0 : _a.lastElementChild);
                    (_c = (_b = toggle.parentElement) === null || _b === void 0 ? void 0 : _b.querySelector('.video-lightbox')) === null || _c === void 0 ? void 0 : _c.classList.add('open');
                }
            });
        });
    }
}
exports.VideoLightbox = VideoLightbox;
